// extracted by css-extract-rspack-plugin
export default {"header":"Vxl8ldGQIp8moU9F","search":"Ce0Tw0DrPpkqmcle","buttons":"KYnHbopF_gAqW1W8"};